export const gs7_contestants = {
    "amateurs": [
        {
            "name": "The Guzzler",
            "campaignUrl": "https://go.dojiggy.io/gyoza/m/138137",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/amateur/Guzzler.png"
        },
        {
            "name": "Quinn Madsen",
            "campaignUrl": "https://go.dojiggy.io/gyoza/m/6a146e",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/amateur/Quinn.png"
        },
        {
            "name": "Stephen Legge",
            "campaignUrl": "https://go.dojiggy.io/gyoza/m/leggend",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/amateur/Legge.png"
        },
        {
            "name": "Jason Cole",
            "campaignUrl": "https://go.dojiggy.io/gyoza/m/e92de3",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/amateur/Cole.png"
        },
        {
            "name": "A Block of Cheez",
            "campaignUrl": "https://go.dojiggy.io/gyoza/m/cheeze",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/amateur/Cheez.png"
        },
        {
            "name": "Jessamyn Reichmann",
            "campaignUrl": "https://go.dojiggy.io/454659/m/sweetheart",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/amateur/Jessamyn.png"
        },
        {
            "name": "Josh Ungurait",
            "campaignUrl": "https://go.dojiggy.io/gyoza/m/josh",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/amateur/Josh.png"
        },
        {
            "name": "Kate Schageman",
            "campaignUrl": "https://go.dojiggy.io/454659/m/crumbs",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/amateur/Kate.png"
        },
        {
            "name": "Nour Benmohamed",
            "campaignUrl": "https://go.dojiggy.io/454659/m/demolisher",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/amateur/Nour.png"
        },
        {
            "name": "Marlon",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/amateur/marlon2.png"
        }
    ],
    "pros": [
        {
            "name": "Crosby Schultz",
            "campaignUrl": "https://go.dojiggy.io/gyoza/m/crozbaby",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/pros/Crosby.png"
        },
        {
            "name": "Conner Deal",
            "campaignUrl": "https://go.dojiggy.io/gyoza/m/corndog",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/pros/Deal.png"
        },
        {
            "name": "Julian Saquic Ray",
            "campaignUrl": "https://go.dojiggy.io/gyoza/m/certifiedeater",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/pros/Julian.png"
        },
        {
            "name": "Jeremy Katz",
            "campaignUrl": "https://go.dojiggy.io/gyoza/m/katz",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/pros/Katz.png"
        },
        {
            "name": "Odin",
            "campaignUrl": "https://go.dojiggy.io/gyoza/m/odin",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/pros/Odin.png"
        },
        {
            "name": "Michael Pascua",
            "campaignUrl": "https://go.dojiggy.io/gyoza/m/pascua",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/pros/Pascua.png"
        },
        {
            "name": "Naader Reda",
            "campaignUrl": "https://go.dojiggy.io/gyoza/m/freak",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/pros/Reda.png"
        },
        {
            "name": "Sam Shirley",
            "campaignUrl": "https://go.dojiggy.io/gyoza/m/mermaid",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/pros/Sam.png"
        },
        {
            "name": "Kenney Tran",
            "campaignUrl": "https://go.dojiggy.io/gyoza/m/gamesonphone",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/pros/Tran.png"
        },
        {
            "name": "Miles Zoltak",
            "campaignUrl": "https://go.dojiggy.io/gyoza/m/miles",
            "img": "https://storage.googleapis.com/gulllet-stuffer.appspot.com/GS7/athletes/pros/Zoltak.png"
        }
    ]
}